// 중앙 상태 화면(완료/대기/만료/에러/검증) 공용 셸 — 부드러운 아이콘 서클 + 위계 정리.
// OnboardingWizard와 OnboardingVerifyScreens가 공유(순환 import 회피로 별도 파일).
import { cn } from '@/lib/utils';

export function StatusScreen({ tone, icon, title, children, footer }: {
  tone: 'teal' | 'amber' | 'rose';
  icon: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  footer: React.ReactNode;
}) {
  const ring = {
    teal: 'bg-teal-50 text-teal-600 ring-teal-100',
    amber: 'bg-amber-50 text-amber-600 ring-amber-100',
    rose: 'bg-rose-50 text-rose-500 ring-rose-100',
  }[tone];
  return (
    <div className="flex flex-col items-center px-1 py-4 text-center">
      <div className={cn('flex h-14 w-14 items-center justify-center rounded-2xl ring-1', ring)}>
        {icon}
      </div>
      <h3 className="mt-4 text-lg font-semibold tracking-tight text-slate-900">{title}</h3>
      {children}
      <div className="mt-6 w-full">{footer}</div>
    </div>
  );
}
